/**
 * MODULE: home/PlatformStatsContext.js
 * PURPOSE: Shared React context so any Home.jsx section (Hero, Live
 *          Intelligence Map, Featured Country, Why Trust) can read live
 *          platform stats (sources_count, etc.) without prop-drilling.
 * PUBLIC API: PlatformStatsCtx (Provider, set in pages/Home.jsx), usePlatformStats()
 * CALLED BY: home/Hero.jsx, home/LiveIntelligenceMapSection.jsx,
 *   home/FeaturedCountrySection.jsx, home/HomeExtras.jsx, pages/Home.jsx
 * LAST REVIEWED: 2026-07-17
 */
import React from "react";

export const PlatformStatsCtx = React.createContext(null);
export const usePlatformStats = () => React.useContext(PlatformStatsCtx);
